/**
 * The suffix for a count: `''` for one, `'s'` for everything else.
 *
 * A function rather than an inline `n === 1 ? '' : 's'` because that inline
 * almost always sits inside another conditional — a count that may be absent, a
 * section that may be empty — and a ternary inside a ternary is what the house
 * rule forbids. Naming it removes the nesting at every call site at once.
 */
export function plural(count: number | undefined): string {
  return count === 1 ? '' : 's';
}
